<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    :more-is-better="moreIsBetter"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { OPERATION, ENTITIES } from '@/services/charts-service';

export default {
  name: 'MetricTotal',
  components: {
    SimpleDataWithVariation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    entity: {
      type: String,
      default: ENTITIES.POSTS,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    metric: {
      type: String,
      default: null,
    },
    operation: {
      type: String,
      default: OPERATION.SUM,
    },
    ownerPosts: {
      type: Boolean,
      default: false,
    },
    metricResolver: {
      type: Function,
      default: (value) => value,
    },
    moreIsBetter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getData(options) {
      let fields;

      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (this.metric) {
        fields = [this.metric];
      }

      this.getChartsService({
        entity: this.entity,
        itemId: this.itemId,
        method: 'getMetricWithVariation',
        params: {
          fields,
          operators: this.operation,
        },
      })
        .then(({ collected_mentions, collected_mentions_variation, collected_previous_mentions }) => {
          this.value = this.metricResolver(collected_mentions);
          this.variation = collected_mentions_variation;
          this.rawVariation = collected_mentions_variation ? collected_mentions_variation : collected_mentions;
          this.comparationValue = this.metricResolver(collected_previous_mentions);
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((error) => {
          this.requestStatus = 'error';
          console.error(error);
        });
    },
  },
};
</script>
